import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-technical-installation-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2483)">
        <path
          d="M0.75 19.371L3.7 16.419C4.44347 16.8579 5.2729 17.1311 6.13164 17.2201C6.99038 17.3091 7.85821 17.2117 8.67587 16.9346C9.49352 16.6575 10.2418 16.2072 10.8695 15.6144C11.4972 15.0217 11.9895 14.3005 12.313 13.5H7.5C6.90326 13.5 6.33097 13.2629 5.90901 12.841C5.48705 12.419 5.25 11.8467 5.25 11.25C5.25 10.6533 5.48705 10.081 5.90901 9.65901C6.33097 9.23705 6.90326 9 7.5 9H12.313C12.0018 8.23699 11.5368 7.54626 10.9469 6.97087C10.3571 6.39548 9.65499 5.94775 8.88449 5.65561C8.11399 5.36346 7.29158 5.23316 6.46851 5.27282C5.64543 5.31249 4.83936 5.52126 4.10052 5.88614C3.36168 6.25101 2.70591 6.76417 2.17411 7.39361C1.6423 8.02306 1.24585 8.7553 1.00947 9.54469C0.773084 10.3341 0.701838 11.1637 0.800169 11.9818C0.898499 12.8 1.1643 13.5891 1.581 14.3L0.75 15.131"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 0.75C16.8522 0.75 16.4706 0.908035 16.1893 1.18934C15.908 1.47064 15.75 1.85218 15.75 2.25C15.75 2.64782 15.908 3.02936 16.1893 3.31066C16.4706 3.59196 16.8522 3.75 17.25 3.75H21.75C22.1478 3.75 22.5294 3.59196 22.8107 3.31066C23.092 3.02936 23.25 2.64782 23.25 2.25C23.25 1.85218 23.092 1.47064 22.8107 1.18934C22.5294 0.908035 22.1478 0.75 21.75 0.75H17.25Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 9.75H18C17.8011 9.75 17.6103 9.67098 17.4697 9.53033C17.329 9.38968 17.25 9.19891 17.25 9V3.75H21.75V9C21.75 9.19891 21.671 9.38968 21.5303 9.53033C21.3897 9.67098 21.1989 9.75 21 9.75Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 6.75H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.506 13.459C18.1558 13.2696 17.7447 13.2271 17.3631 13.3409C16.9816 13.4546 16.6609 13.7153 16.4715 14.0655C16.2821 14.4157 16.2397 14.8268 16.3534 15.2084C16.4671 15.5899 16.7278 15.9106 17.078 16.1L21.036 18.241C21.3862 18.4304 21.7973 18.4728 22.1789 18.3591C22.5604 18.2454 22.8811 17.9847 23.0705 17.6345C23.2599 17.2843 23.3024 16.8732 23.1886 16.4916C23.0749 16.1101 22.8142 15.7894 22.464 15.6L18.506 13.459Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.521 23.16L14.883 21.732C14.7084 21.6369 14.5787 21.4763 14.5225 21.2856C14.4662 21.0949 14.488 20.8897 14.583 20.715L17.083 16.098L21.041 18.239L18.541 22.857C18.4941 22.944 18.4304 23.0209 18.3537 23.0832C18.277 23.1456 18.1887 23.1922 18.0939 23.2203C17.9992 23.2485 17.8998 23.2576 17.8014 23.2473C17.7031 23.2369 17.6078 23.2073 17.521 23.16Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.331 18.022L20.928 21.592"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2483">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessTechnicalInstallationInsuranceIconComponent extends BaseIconComponent {}
